/*
 * Those parameters are on Azure Key Vault;
 * They are overridden during DevOps Pipeline with secrets value on KV in PowerShell@2 task.
 * 
 * To update any, you must update on Key Vault.
 *
 * To add any, you must on Key Vault, add at Pipeline and after adding on this file.
 *
 * To run locally, you must go to Dev Pipeline and match each key with the secret and replace it with KV value.
 */

export const environment = {
  ENVIRONMENT_PLACE_NAME: 'QA',
  IS_PRODUCTION: 'false',
  ENVIRONMENT_VERSION: '1.0.0-prod',
  SERVER_URL: 'https://ctinvoic-api-qa.azurewebsites.net',
  CLIENT_ID: '3e7f30db-c0bd-49c5-af0c-633de25b3a94',
  TENANT_ID: 'f25493ae-1c98-41d7-8a33-0be75f5fe603',
  ENVIRONMENT_AUTHORITY: 'https://login.microsoftonline.com/f25493ae-1c98-41d7-8a33-0be75f5fe603',
  REDIRECT_URI: 'https://qa.invoicerequest.volvotrucks.net/',
  POST_LOGOUT_REDIRECT_URI: 'ctinvoic-ui-qa.azurewebsites.net',
  GRAPH_ENDPOINT: 'https://graph.microsoft.com/v1.0',
  APPINSIGHTS_CONNECTION_STRING: 'InstrumentationKey=3b91f5f0-54fd-48e6-8c03-b157f126d903;IngestionEndpoint=https://swedencentral-0.in.applicationinsights.azure.com/;LiveEndpoint=https://swedencentral.livediagnostics.monitor.azure.com/;ApplicationId=196481bd-4479-474c-980b-54ccf331b06c',
  MASTERSAF_URL: 'https://h.dfe.mastersaf.com.br/mvc/login'
};
